import { render, staticRenderFns } from "./ScoreboardLive.vue?vue&type=template&id=7f691394&scoped=true"
import script from "./ScoreboardLive.vue?vue&type=script&lang=js"
export * from "./ScoreboardLive.vue?vue&type=script&lang=js"
import style0 from "./ScoreboardLive.vue?vue&type=style&index=0&id=7f691394&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f691394",
  null
  
)

export default component.exports